import { Component, OnInit } from '@angular/core';
import { WebSocketService } from './shared/services/websocket.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(private webSocketService: WebSocketService) {}

  title = 'Bonnapp - Administrador';

  ngOnInit(): void {
    console.log('AppComponent inicializado, WebSocketService ativo.');
    this.webSocketService.setUserId(localStorage.getItem('userId') || '');
  }
}
